import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;
  width: 50%;

  // Full width for Listings on mobile
  ${({ theme }) => theme.media.sm`
    width: 100%;
  `}
`;
